import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration from your provided credentials
const firebaseConfig = {
  apiKey: "AIzaSyCy06DkUn5uH1CTZhr_JPoz-sPsBbuuouI",
  authDomain: "screens-163c9.firebaseapp.com",
  databaseURL: "https://screens-163c9-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "screens-163c9",
  storageBucket: "screens-163c9.firebasestorage.app",
  messagingSenderId: "128216300058",
  appId: "1:128216300058:web:b4939331ab935f9b622fa3",
  measurementId: "G-VX6DGR33PS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Set auth persistence to local storage
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.warn('Auth persistence error:', error);
});

// Enable offline persistence
try {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('Persistence failed: Multiple tabs open');
    } else if (err.code === 'unimplemented') {
      console.warn('Persistence not supported');
    }
  });
} catch (e) {
  console.warn('Persistence setup error:', e);
}

export default app;
